"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = removeNullValues;
function removeNullValues(obj) {
    return Object.entries(obj).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        if (value !== null) {
            // Only include properties where the value is not null
            acc[key] = value;
        }
        return acc;
    }, {}); // Start with an empty object as the accumulator
}
